import React from 'react';
import {
  Button,
  Card,
  CardActions,
  CardBody,
  CardMedia,
  CardTitle
} from '@one-thd/sui-atomic-components';
import { Email, Delivery } from '@one-thd/sui-icons';
import { navigateToGiftCardPIPPage } from '../../utils/util';

const ListPod = (data) => {
  let listData = data?.item;
  const { digital, physical } = listData;
  const showAtc = listData.digital || listData.physical;
  const { max, min } = listData;

  const btnClick = () => {
    navigateToGiftCardPIPPage(listData);
  };

  return (
    <Card CardContentProps={{ grow: true }}>
      <div className="sui-mx-auto">
        <CardMedia
          className="sui-rounded-md sui-cursor-pointer"
          src={listData.image}
          alt={listData.name}
          onClick={btnClick}
        />
      </div>
      <div>
        <p className="sui-h4-display sui-flex sui-items-center sui-whitespace-pre-wrap">
          {listData.min !== listData.max && (
            <>
              <span className="sui-text-lg">$</span>
              <span data-testid="min-value">{min}</span>
              <span> - </span>
            </>
          )}
          {max && (
            <>
              <span className="sui-text-lg">$</span>
              <span data-testid="max-value">{max.toLocaleString('en-US')}</span>
            </>
          )}
        </p>
      </div>
      <CardTitle headerVariant="h5" header={listData.brandName} subheader={listData.name} />
      <CardBody>
        {digital && (
          <div className="sui-flex sui-items-center">
            <Email size="small" /> <span className="sui-ml-2">Digital</span>
          </div>
        )}
        {physical && (
          <div className="sui-flex sui-items-center">
            <Delivery size="small" /> <span className="sui-ml-2">Physical</span>
          </div>
        )}
      </CardBody>
      <CardActions>
        <Button
          fullWidth
          variant="secondary"
          data-testid="choose-options"
          type="button"
          disabled={!showAtc}
          onClick={btnClick}
        >
          Choose Options
        </Button>
      </CardActions>
    </Card>
  );
};

export default ListPod;
